export default class Expense {
    constructor({ id, title, expense_matchers = [] }) {
        this.id = id;
        this.title = title;
        this.matchers = expense_matchers.map((matcher) => ({
            id: matcher.id,
            title: matcher.title,
        }));

        Object.freeze(this);
    }

    get matcherTitles() {
        return this.matchers.map((matcher) => matcher.title);
    }

    get hasMatchers() {
        return this.matchers.length > 0;
    }
}
